import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import ReactModal from 'react-modal';
import { CookiesProvider } from 'react-cookie';

import 'react-loading-skeleton/dist/skeleton.css';

import { Sentry, i18n, config } from '@formue-app/core';

import * as serviceWorker from './serviceWorker';
import { store } from './store';
import { setRouter } from './store/navigation';
import { routeTree } from './config/routeTree';
import { StyledComponentsProvider } from './config/styledComponents';
import {
  redactEvent,
  redactBreadcrumb,
} from './services/sentry/redactAuthParams';
ReactModal.setAppElement('#root');

// Created once, outside React. Sagas and the AI action executors navigate
// through this instance via `store/navigation`, which is what
// `connected-react-router` used to do by dispatching redux actions.
const router = createBrowserRouter(routeTree);
setRouter(router);

Sentry.init({
  dsn: 'https://e159c08316714d14a00ff8ab03c17f58@o262048.ingest.sentry.io/5456773',
  release: process.env.REACT_APP_RELEASE || undefined,
  environment: process.env.NODE_ENV,
  initialScope: { tags: { brand: config.countryCode } },
  beforeSend: redactEvent,
  beforeBreadcrumb: redactBreadcrumb,
});

(async () => {
  await i18n.init();
  const root = createRoot(document.getElementById('root'));

  root.render(
    <React.StrictMode>
      <StyledComponentsProvider>
        <Provider store={store}>
          <CookiesProvider>
            <RouterProvider router={router} />
          </CookiesProvider>
        </Provider>
      </StyledComponentsProvider>
    </React.StrictMode>
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
